/* globals angular, _ */
(function() {
  'use strict';

  function NotFoundPanelCtrl (mdPanelRef, $rootScope, localStorageService) {
    var ctrl = this;

    ctrl.close = function () {
      return mdPanelRef.close();
    };

    ctrl.corrigir = function () {
      ctrl.close().then(function () {
        $rootScope.$emit('manual_registration:show', ctrl.encomenda);
      });
    }

    ctrl.openTicketForm = function () {
      if (!mdPanelRef) { return; }
      mdPanelRef.close().then(function() {
        var dataObj = {
          id: '',
          trackingCode: ctrl.encomenda.codigoRastreamento,
          shipping: '',
          incident: 'Encomenda sem registro no sistema',
          trackingUrl: '',
          extras: '',
          appendText: "-----\nChave de acesso NF-e: " + ctrl.encomenda.chaveAcessoNfe,
        };
        $rootScope.$emit('ticket_form:show', dataObj);
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('NotFoundPanelCtrl', NotFoundPanelCtrl);
}());
